export default __webpack_public_path__ + "static/media/bg_login.5362ce78.png";